import React, { useState } from 'react';
import './App.css';
import SplashScreen from './components/SplashScreen';
import Header from './components/Header';
import Hero from './components/Hero';
import PurposeSection from './components/PurposeSection';
import ServicesSection from './components/ServicesSection';
import ProjectsSection from './components/ProjectsSection';
import AboutSection from './components/AboutSection';
// import StatsSection from './components/StatsSection';
import TestimonialSection from './components/TestimonialSection';
import CTASection from './components/CTASection';
import Footer from './components/Footer';
import WhatsAppFloat from './components/WhatsAppFloat';

function App() {
  const [showSplash, setShowSplash] = useState(true);

  const handleSplashComplete = () => {
    setShowSplash(false);
  };

  return (
    <div className="App">
      {showSplash && <SplashScreen onComplete={handleSplashComplete} />}
      <Header />
      <Hero />
      <PurposeSection />
      <ServicesSection />
      <ProjectsSection />
      <AboutSection />
      {/* <StatsSection /> */}
      <TestimonialSection />
      <CTASection />
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}

export default App;
